import { Pipe, PipeTransform } from '@angular/core';
import { NotificationInfoHandler } from 'src/app/core/services/notification-info-handler.service';

@Pipe({
  name: 'notificationContent'
})
export class NotificationContentPipe implements PipeTransform {

  constructor(private notificationInfoHandler: NotificationInfoHandler) {

  }

  transform(value: any, ...args: any[]): any {
    const handler = this.notificationInfoHandler.getTransformer(value.systemCode);
    return handler?.getContent(value);
  }
}
